"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeReleaseStatus = exports.ReleaseStatus = exports.Instructor = exports.COURSE_TRACK_TO_APPLICATION_MATERIAL = exports.TRACK_TO_EXAMS = exports.Exam = exports.COURSE_ORGANIZATION_TO_TRACKS = exports.CourseTrack = exports.CourseOrganization = void 0;
var CourseOrganization;
(function (CourseOrganization) {
    CourseOrganization["SOA"] = "SOA";
    CourseOrganization["CAS"] = "CAS";
    CourseOrganization["NONE"] = "None";
    CourseOrganization["OTHER"] = "Other";
})(CourseOrganization || (exports.CourseOrganization = CourseOrganization = {}));
var CourseTrack;
(function (CourseTrack) {
    CourseTrack["FSA_HEALTH"] = "FSA - Group and Health";
    CourseTrack["FSA_CORPORATE_FINANCE"] = "FSA - Corporate Finance and ERM";
    CourseTrack["FSA_QUANTITATIVE_FINANCE"] = "FSA - Quantitative Finance and Investment";
    CourseTrack["FSA_LIFE"] = "FSA - Individual Life and Annuities";
    CourseTrack["FSA_RETIREMENT"] = "FSA - Retirement Benefits";
    CourseTrack["FSA_GENERAL"] = "FSA - General Insurance";
    CourseTrack["CAS"] = "CAS";
    CourseTrack["NONE"] = "None";
    CourseTrack["OTHER"] = "Other";
    CourseTrack["SAMPLE"] = "Sample";
})(CourseTrack || (exports.CourseTrack = CourseTrack = {}));
exports.COURSE_ORGANIZATION_TO_TRACKS = {
    [CourseOrganization.SOA]: [
        CourseTrack.FSA_HEALTH,
        CourseTrack.FSA_CORPORATE_FINANCE,
        CourseTrack.FSA_QUANTITATIVE_FINANCE,
        CourseTrack.FSA_LIFE,
        CourseTrack.FSA_RETIREMENT,
        CourseTrack.FSA_GENERAL,
    ],
    [CourseOrganization.CAS]: [CourseTrack.CAS],
    [CourseOrganization.NONE]: [],
    [CourseOrganization.OTHER]: [],
};
var Exam;
(function (Exam) {
    Exam["design_and_pricing"] = "Design and Pricing";
    Exam["risk_mitigation"] = "Risk Mitigation";
    Exam["valuation_and_regulation_us"] = "Valuation and Regulation - US";
    Exam["valuation_and_regulation_can"] = "Valuation and Regulation - CAN";
    Exam["enterprise_risk_management"] = "Enterprise Risk Management";
    Exam["foundations_of_cfe"] = "Foundations of CFE";
    Exam["strategic_decision_making"] = "Strategic Decision Making";
    Exam["quantitative_finance"] = "Quantitative Finance";
    Exam["portfolio_management"] = "Portfolio Management";
    Exam["investment_risk_management"] = "Investment Risk Management";
    Exam["life_product_management"] = "Life Product Management";
    Exam["life_financial_management"] = "Life Financial Management";
    Exam["life_alm_and_modeling"] = "Life ALM and Modeling";
    // enrolled actuaries ??
    Exam["design_and_accounting"] = "Design and Accounting";
    Exam["retirement_investment_plan"] = "Retirement Plan Investment and Risk Management";
    Exam["intro_to_general_insurance"] = "Introduction to General Insurance";
    Exam["ratemaking_and_reserving"] = "Ratemaking and Reserving";
    Exam["financial_and_regulatory_environment"] = "Financial and Regulatory Environment Exam";
    Exam["advanced_topics_in_general_insurance"] = "Advanced Topics In General Insurance";
    // CAS
    Exam["estimation_of_policy_liabilities"] = "Exam 7 - Estimation of Policy Liabilities";
    Exam["advanced_ratemaking"] = "Exam 8 - Advanced Ratemaking";
    Exam["financial_risk_and_rate_of_return"] = "Exam 9 - Financial Risk and Rate of Return";
})(Exam || (exports.Exam = Exam = {}));
exports.TRACK_TO_EXAMS = {
    [CourseTrack.FSA_HEALTH]: [
        Exam.design_and_pricing,
        Exam.risk_mitigation,
        Exam.valuation_and_regulation_us,
        Exam.valuation_and_regulation_can,
    ],
    [CourseTrack.FSA_CORPORATE_FINANCE]: [
        Exam.enterprise_risk_management,
        Exam.foundations_of_cfe,
        Exam.strategic_decision_making,
    ],
    [CourseTrack.FSA_QUANTITATIVE_FINANCE]: [
        Exam.quantitative_finance,
        Exam.portfolio_management,
        Exam.investment_risk_management,
    ],
    [CourseTrack.FSA_LIFE]: [
        Exam.life_product_management,
        Exam.life_financial_management,
        Exam.life_alm_and_modeling,
    ],
    [CourseTrack.FSA_RETIREMENT]: [
        Exam.design_and_accounting,
        Exam.retirement_investment_plan,
        // EA??
    ],
    [CourseTrack.FSA_GENERAL]: [
        Exam.intro_to_general_insurance,
        Exam.ratemaking_and_reserving,
        Exam.financial_and_regulatory_environment,
        Exam.advanced_topics_in_general_insurance,
    ],
    [CourseTrack.CAS]: [
        Exam.estimation_of_policy_liabilities,
        Exam.advanced_ratemaking,
        Exam.financial_risk_and_rate_of_return,
    ],
    [CourseTrack.NONE]: [],
    [CourseTrack.OTHER]: [],
    [CourseTrack.SAMPLE]: [],
};
// https://docs.google.com/spreadsheets/d/1BFtDmo6fzy9-i_oQSZVUYWhCymxlMSxjNWTM65dfGoo/edit#gid=0
exports.COURSE_TRACK_TO_APPLICATION_MATERIAL = {
    [CourseTrack.FSA_HEALTH]: {
        link: 'https://www.cia-ica.ca/docs/default-source/2006/206134e.pdf',
        Topic: 'Underwriting',
        Subtopic: 'Websites',
        Chapter: 'Level Funding: An Alternative to ACA for Small Groups',
    },
    [CourseTrack.FSA_CORPORATE_FINANCE]: {
        link: 'https://www.soa.org/globalassets/assets/files/resources/research-report/2018/national-risk-management.pdf',
        Topic: 'Risk Categories and Identification',
        Subtopic: 'Websites',
        Chapter: 'National Risk Management A Practical ERM Approach for Federal Governments',
    },
    [CourseTrack.FSA_QUANTITATIVE_FINANCE]: {
        link: 'https://www.soa.org/4a57cc/globalassets/assets/files/resources/research-report/2022/understanding-the-connection.pdf',
        Topic: 'Interest Rate Models and Hedging',
        Subtopic: 'Websites',
        Chapter: 'Understanding the Connection between Real-World and Risk-Neutral Scenario Generators',
    },
    [CourseTrack.FSA_LIFE]: {
        link: 'https://www.soa.org/globalassets/assets/files/resources/research-report/2022/mechanics-dividends.pdf',
        Topic: 'Product Management, Operations and Studies',
        Subtopic: 'Websites',
        Chapter: 'Mechanics of Dividends',
    },
    [CourseTrack.FSA_RETIREMENT]: {
        link: 'https://www.tandfonline.com/doi/pdf/10.1080/10920277.2019.1672566',
        Topic: 'Investment Risk Management',
        Subtopic: 'Websites',
        Chapter: 'New Solutions to an Age-Old Problem: Innovative Strategies for Managing Pension and Longevity Risk',
    },
    [CourseTrack.FSA_GENERAL]: {
        link: 'https://www.soa.org/globalassets/assets/files/edu/2023/spring/study-note/fre-802-19.pdf',
        Topic: 'Financial Reporting',
        Subtopic: 'Study Notes',
        Chapter: 'FRE-802-19: National Association of Insurance Commissioners (NAIC), Accounting Practices and Procedures Manual, 2018, Preamble',
    },
    [CourseTrack.CAS]: {
        link: 'https://www.casact.org/sites/default/files/2021-03/8_Couret_Venter.pdf',
        Topic: 'Classification Ratemaking',
        Subtopic: 'Section 2',
        Chapter: 'Using Multi-Dimensional Credibility to Estimate Class Frequency Vectors in Workers Compensation',
    },
    [CourseTrack.OTHER]: null,
    [CourseTrack.NONE]: null,
    [CourseTrack.SAMPLE]: {
        link: 'https://www.soa.org/globalassets/assets/Library/Newsletters/Health-Watch-Newsletter/2016/may/hsn-2016-iss-80-slater.pdf',
        Topic: 'Underwriting',
        Subtopic: 'Websites',
        Chapter: 'Level Funding - An Alternative to ACA for Small Groups',
    },
};
var Instructor;
(function (Instructor) {
    Instructor["unassigned"] = "unassigned";
    Instructor["andrew"] = "andrew";
    Instructor["sean"] = "sean";
    Instructor["sue"] = "sue";
})(Instructor || (exports.Instructor = Instructor = {}));
// denotes release status of a course
var ReleaseStatus;
(function (ReleaseStatus) {
    ReleaseStatus["notAvailable"] = "notAvailable";
    ReleaseStatus["waitlistOnly"] = "waitlistOnly";
    ReleaseStatus["hiddenButAvailable"] = "hiddenButAvailable";
    ReleaseStatus["fullyAvailable"] = "fullyAvailable";
})(ReleaseStatus || (exports.ReleaseStatus = ReleaseStatus = {}));
// denotes release status of a node within a course
var NodeReleaseStatus;
(function (NodeReleaseStatus) {
    NodeReleaseStatus["released"] = "released";
    NodeReleaseStatus["inProgress"] = "inProgress";
})(NodeReleaseStatus || (exports.NodeReleaseStatus = NodeReleaseStatus = {}));
//# sourceMappingURL=types.js.map